import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper/";
import media from "styled-media-query";

export const SearchPaginationWrapper = styled.div`
    display: flex;
    margin: 0;
    width: calc(100% / 3 - (1.5rem * 2 / 3));

    ${media.lessThan(breakpoints.large)`           
            width: calc(100% / 2 - (1.5rem * 1 / 2));
        `}
    ${media.lessThan(breakpoints.mobile)`
			 width: 100%;
        `}
    > div, > a {
        width: 100%;
        margin: 0;

        iframe {
            height: 100%;
        }
    }
`;

export const HitsPaginationWrapper = styled.div`
	max-width: 1170px;
	padding: 1rem 0;	
	display: flex;
	flex-wrap: wrap;
    gap: 20px;
`;